import { useEffect, useState } from "react"
import ListProductHeader from "../ListProductHeader"
import axiosInstance from "../../Services/Api"

const ListProducts = ({ setShowListProducts }) => {
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get('/checkout/products');
                // Maneja la respuesta aquí
                setIsLoading(false)
                console.log(response.data.products)
                setProducts(response.data.products);
            } catch (error) {
                setIsLoading(false)
                if (error.status === 401) {
                    window.localStorage.removeItem('token')
                    window.location.href = '/#/login'
                }
                console.error('Error fetching data:', error);
            }
        };
        fetchData()
    }, [])
    const handleSelectProduct = (productId) => {
        // 1. Dividir hash e query params existentes
        const [hashPath, existingQuery] = window.location.hash.split('?');

        // 2. Criar objeto URLSearchParams
        const params = new URLSearchParams(existingQuery || '');

        // 3. Atualizar parâmetro
        params.set('productId', productId);

        // 4. Reconstruir URL
        const newHash = `${hashPath}?${params.toString()}`;

        // 5. Atualizar histórico
        window.history.pushState({}, '', newHash);
        window.location.reload()
    };

    if (isLoading) {
        return (
            <div className="flex justify-center h-screen items-center mt-8">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-500"></div>
            </div>
        );
    }
    return (
        <div>
            <ListProductHeader setShowListProducts={setShowListProducts} />
            <div className="px-4 md:z-0  relative z-[99999] mt-4 w-full">
                {products.length === 0 ?
                    <div className="flex flex-col items-center justify-center min-h-[300px] p-8 text-center">
                        <div className="mb-6">
                            <div onClick={()=>{setShowListProducts(false)}} className=" cursor-pointer mx-auto bg-gray-100 rounded-full p-4">
                                <svg
                                    className="w-12 h-12 text-gray-600"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                    />
                                </svg>
                            </div>
                        </div>

                        <h3 className="text-xl font-semibold text-gray-300 mb-2">
                            Nenhum produto encontrado
                        </h3>

                        <p className="text-gray-600 mb-6 max-w-md">
                            Você ainda não possui produtos cadastrados. Comece a vender agora mesmo
                            criando seu primeiro produto em nossa plataforma!
                        </p>

                        <p className="mt-4 text-sm text-gray-500">
                            Leva menos de 2 minutos para cadastrar 🚀
                        </p>
                    </div>
                    : <div className="grid md:grid-cols-3 gap-3 w-full">
                        {products.map((product, index) => {
                            return (
                                <div onClick={() => handleSelectProduct(product.id)} key={index} className="bg-[#3D3D3D] max-h-[150px] p-3 cursor-pointer rounded-[8px] border border-[#A2A2A2]">
                                    <div className="flex items-center gap-3">
                                        <img className="max-h-[100px] max-w-[120px]" src={process.env.REACT_APP_API_URL + '/' + product.image} />
                                        <div>
                                            <h2>{product.name}</h2>
                                            <p className="line-clamp-2 text-[12px]">
                                                {product.description}
                                            </p>
                                            <span className="text-[12px]">
                                                {new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(product.price)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>}
            </div>
        </div >
    )
}


export default ListProducts